import { Stack, Tooltip, Typography } from '@mui/material'
import React, { type ReactNode } from 'react'

import { ChipListMultiValue } from 'components/common/chips/ChipList'
import { ChipWithTooltip } from 'components/common/chips/ChipWithTooltip'
import Icon from 'components/Icon'
import { ObservabilityToolEditor } from 'components/status-checks/common/ObservabilityToolEditor'
import { EditTagsDrawer } from 'components/status-checks/edit/EditTagsDrawer'
import { useFeatureFlags } from 'hooks/use-feature-flags'

import type { ServiceStatusCheckFromStatusCheck } from 'types/api/status-checks/status-check'

export function MonitorDetails({
  header,
  statusCheck,
  tagsFromMonitor
}: {
  header?: ReactNode
  statusCheck: ServiceStatusCheckFromStatusCheck
  tagsFromMonitor?: string[]
}) {
  const { multiPniRouting: isMultiPniRoutingEnabled } = useFeatureFlags()

  const isClone = !statusCheck.id
  const canEditTags = isMultiPniRoutingEnabled && !isClone

  return (
    <Stack sx={{ gap: 2, paddingBottom: 1 }}>
      <ObservabilityToolEditor integration={statusCheck.integration} />
      {/* Header: name, monitor link, etc */}
      {header}
      {/* Tags */}
      {tagsFromMonitor && (
        <Stack
          direction="row"
          sx={{ alignItems: 'center', flexWrap: 'wrap', gap: 1 }}
        >
          <Typography>Tags from Observability Tool:</Typography>
          {tagsFromMonitor.map((tag) => (
            <ChipWithTooltip
              key={tag}
              label={tag}
              tooltipProps={{ title: tag }}
            />
          ))}
        </Stack>
      )}
      {isMultiPniRoutingEnabled && (
        <Stack
          direction="row"
          sx={{ alignItems: 'center', flexWrap: 'wrap', gap: 1 }}
        >
          <Typography>Tags:</Typography>
          {statusCheck.multiSelectTags && (
            <ChipListMultiValue tags={statusCheck.multiSelectTags} />
          )}
          {canEditTags && (
            <EditTagsDrawer
              monitorTags={
                // Note: we may pass in monitor tags in the future when they can be used by Gremlin
                undefined
              }
              statusCheck={statusCheck}
            />
          )}
          {isClone && (
            <Tooltip title="Tags can be edited once health check is saved">
              <Icon icon="solidCircleInfo" />
            </Tooltip>
          )}
        </Stack>
      )}
    </Stack>
  )
}
